var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 426 896"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M269.77 197.07c0-34.88 36.09-42.97 52.94-42.97h100.67V.58L308 0C150.55 0 114.62 114.46 114.62 187.85v123H.38V469h114.24v427h155.15V469h131.79l24.06-158.16H269.77z"
  })));
};
export default SvgFacebook;